import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { UntilDestroy } from '@ngneat/until-destroy';
import { JobLogsModule } from '../job-logs/job-logs.module';
import { JobLogsDialogData } from '../model';

@UntilDestroy()
@Component({
  selector: 'y42-job-logs-dialog',
  templateUrl: './job-logs-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [CommonModule, JobLogsModule],
})
export class JobLogsDialogComponent {
  constructor(
    private readonly dialogRef: MatDialogRef<JobLogsDialogComponent>,
    @Inject(MAT_DIALOG_DATA) readonly data: JobLogsDialogData,
  ) {}

  cancel() {
    this.dialogRef.close();
  }
}
